import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../auth/useAuth";
import Loader from "./loader";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  // ⏳ Wait for auth resolution
  if (loading) {
    return <Loader />;
  }

  // 🚪 Not authenticated → go HOME
  if (!user) {
    const redirectPath = `${location.pathname}${location.search}${location.hash}`;
    sessionStorage.setItem("postLoginRedirect", redirectPath);
    localStorage.setItem("postLoginRedirect", redirectPath);
    return <Navigate to="/?openLogin=true" replace state={{ from: location }} />;
  }

  return children;
}
